//? PLUGINS //
import { Box, BoxProps, Card, CircularProgress, StepConnector, useMediaQuery, useTheme, withStyles } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

//? EXTRA //
import { ReactComponent as Itsme } from 'resources/itsme.svg';
import * as authenticationService from 'services/AuthenticationService';

//? STYLES //
import * as Styles from 'pages/auth/login/login.styles';
import { useAuthContext } from 'contexts/authContext';

//! -------------------------------------------------------- //

interface LoginProps {
    showMessage: MessageBox;
}

const Login = (props: LoginProps) => {
    const { showMessage } = props;
    const [user, setUser] = React.useState<authenticationService.User>({} as authenticationService.User);
    const [loading, setLoading] = React.useState<boolean>(true);
    const { checkIfUserLoginWasSucces, getUser } = useAuthContext();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const redirectUri = new URLSearchParams(window.location.search).get('redirectUri') || '/beheer';
    const [hasLoginFailed, setHasLoginFailed] = React.useState(false);
    const theme = useTheme();

    const handleClickBpolb = () => {
        authenticationService.loginBpolb(redirectUri, true);
    };

    const handleClickLocal = () => {
        authenticationService.loginBpolb(redirectUri);
    }

    useEffect(() => {
        let params = new URLSearchParams(window.location.search);
        let code = params.get('code');
        setLoading(false)

        if (code) {
            setLoading(true)
            checkIfUserLoginWasSucces(redirectUri);
            // authenticationService.checkAuthUser().then((user) => {
            //     setUser(user);
            //     if (user && authenticationService.isAuthenticated(user)) {
            //         navigate(redirectUri);
            //     }
            // });
        }
        else {
            getUser('login')
                .then((resp) => {
                    if (resp) navigate('/beheer');
                });
            // authenticationService.getUserAsync().then((user) => {
            //     if (user && authenticationService.isAuthenticated(user)) {
            //         navigate('/beheer');
            //     }
            // });
        }

        // switch (state) {
        // 	case 'confirm':
        // 		authenticationService.updateToken().then(() => {
        // 			console.log('update token')
        // 			navigate(`${redirectUriLocal}`);
        // 		}).catch(err => {
        // 			if (err.response.status == 401)
        // 			navigate('/unauthorized');
        // 		});
        // 		break;
        // 	case 'failed':
        // 		navigate(`/login?state=failed&redirectUri=${redirectUri}`);
        // 		setHasLoginFailed(true);
        // 		break;
        // }

        // localStorage.removeItem('loginLocation');
        // localStorage.removeItem('redirectUri');

        if (hasLoginFailed) {
            showMessage(t('login.failed'), 'error');
        }
    }, [navigate, redirectUri, hasLoginFailed, showMessage, t]);


    const titleBox: BoxProps = {
        component: 'h1',
        sx: Styles.Title
    }
    const subTitleBox: BoxProps = {
        component: 'h4',
        sx: Styles.Subtitle
    }
    const bpolbText: BoxProps = {
        sx: Styles.BpolbText
    }
    const bpolbBox: BoxProps = {
        onClick: handleClickBpolb,
        sx: Styles.ButtonBpolb
    }

    const localBox: BoxProps = {
        onClick: handleClickLocal,
        sx: Styles.ButtonBpolb
    }

    return (
        <Box sx={Styles.Container}>

            {loading ?
                <CircularProgress size={'5rem'} /> :
                <Card sx={Styles.Card}>
                    <Box>
                        <Box {...titleBox}>{t('login.titleAdmin')}</Box>
                        {/* <Box {...subTitleBox}>{t('login.subtitle')}</Box> */}
                        <StepConnector />
                    </Box>

                    <Box {...bpolbBox}>
                        <Box {...bpolbText}>
                            {t('login.bpolb')}
                        </Box>
                    </Box>
                    <Box {...localBox}>
                        <Box {...bpolbText}>
                            {t('login.local')}
                        </Box>
                    </Box>
                </Card>
            }

            {/* <Card sx={Styles.Card}>
				<Box>
					<Box {...titleBox}>{t('login.title')}</Box>
					<Box {...subTitleBox}>{t('login.subtitle')}</Box>
					<StepConnector />
				</Box>

				<Box {...itsmeBox}>
					<Box {...itsmeLogo}>
						<Itsme width='40px' />
					</Box>
					<Box {...itsmeText}>
						{t('login.itsme')} <sup aria-hidden="true">®</sup>
					</Box>
				</Box>

			</Card> */}
        </Box>
    );
};

export default Login;
